// extracted by mini-css-extract-plugin
module.exports = {"marketIconStarSubTitle":"_b42c417","marketIcon":"_a806df3","container":"_88c3005","marketIconBetBuilderIcon":"_9766d97","marketIconStarSubTitleBadge":"_31f3d1b"};